import { Graphics } from "pixi.js";
import { CommonData } from "../../../datastructures/gamestate/gameData";
import { GameRoundDisplay } from "../gameRoundDisplayOverlay/gameroundDisplayer";

export class AlwaysVisibleGameBlackBar extends PIXI.Container {
  private landscapeParent: PIXI.Container;
  private portraitParent: PIXI.Container;
  private activeGameData: CommonData;
  private displayBlackGround: PIXI.Graphics;
  private textStyle = {
    strokeThickness: 4,
    stroke: 0x000000,
    fill: 0xffffff,
    align: "right",
    fontSize: 18,
  };
  private display_gameNameText: PIXI.Text = new PIXI.Text("", this.textStyle);
  private display_clock: PIXI.Text = new PIXI.Text("", this.textStyle);
  private display_gameModeText: PIXI.Text = new PIXI.Text("", this.textStyle);
  private intervalClockId: ReturnType<typeof setInterval> | undefined;
  private mainContainer: PIXI.Container = new PIXI.Container();
  private gameroundContainer: PIXI.Container = new PIXI.Container();
  constructor(activeGameData: CommonData) {
    super();
    this.activeGameData = activeGameData;
    this.addChild(this.mainContainer);
    this.displayBlackGround = new Graphics()
      .beginFill(0x000000)
      .drawRect(-20, -10, 40, 20)
      .endFill();
    this.mainContainer.addChild(this.displayBlackGround);
    this.mainContainer.addChild(this.display_clock);
    this.mainContainer.addChild(this.display_gameNameText);
    this.mainContainer.addChild(this.gameroundContainer);
    this.mainContainer.addChild(this.display_gameModeText);
    this.display_clock.anchor.set(0, 0.5);
    this.display_clock.alpha = 0.5;
    this.display_gameNameText.anchor.set(0.5);
    this.display_gameNameText.alpha = 0.5;
    this.display_gameModeText.anchor.set(1, 0.5);
    this.display_gameModeText.alpha = 0.5;

    //add game round displayer
    this.activeGameData.gameRoundDisplayOverlay = new GameRoundDisplay(
      this.gameroundContainer,
      this.activeGameData.gameTextStyle.gameFont
    );

    this.updateGameNameText("---");

    //--update clock
    this.startInterval();
  }

  // Method to start the interval
  startInterval(): void {
    this.intervalClockId = setInterval(() => this.updateClock(), 1000);
  }

  stopInterval(): void {
    if (this.intervalClockId !== undefined) {
      clearInterval(this.intervalClockId);
      this.intervalClockId = undefined;
    }
  }

  private updateClock = (): void => {
    const now = new Date();
    const hours = now
      .getHours()
      .toString()
      .padStart(2, "0");
    const minutes = now
      .getMinutes()
      .toString()
      .padStart(2, "0");
    this.display_clock.text = `${hours}:${minutes}`;
  };

  public updateGameModeText = (newText: string): void => {
    this.display_gameModeText.text = "Mode:" + newText;
    this.displayBlackGround.width = this.display_gameModeText.width + 20;
    this.display_gameModeText.height = this.display_gameModeText.height;
  };

  public updateGameNameText = (newText: string): void => {
    this.display_gameNameText.text = newText;
    this.displayBlackGround.width = this.display_gameNameText.width + 20;
    this.displayBlackGround.height = this.display_gameNameText.height;
  };

  private setPosition = (newPos: { x: number; y: number }): void => {
    this.x = newPos.x;
    this.y = newPos.y;
  };
  public setInPortraitMode = (): void => {
    this.visible = true;
    this.portraitParent.addChild(this);
    //portrait //snap the interface to right of the screen
    this.scale.set(2);
    let canvas = document.getElementsByTagName("canvas")[0];
    let moveX = this.activeGameData.size[0] * 2;
    let canvasWidth = canvas.width / this.activeGameData.gameScene.scale.x;
    if (canvasWidth > this.activeGameData.size[0]) {
      moveX = canvasWidth + this.activeGameData.size[0];
    }
    moveX;
    this.setPosition({
      x: this.activeGameData.size[0] / 2,
      y: -this.height / 2,
    });
    this.displayBlackGround.width = canvasWidth;
    this.display_clock.x = -this.activeGameData.size[0] / 4 + 50;

    this.display_gameModeText.x = this.activeGameData.size[0] / 4 - 50;

    //-
    this.gameroundContainer.x = this.display_clock.x + 50;
  };

  public setInLandscapeMode = (): void => {
    this.landscapeParent.addChild(this);
    this.visible = true;
    //landscape //snap the interface to right of the screen
    this.scale.set(1);
    let canvas = document.getElementsByTagName("canvas")[0];
    let moveX = this.activeGameData.size[0] * 2;
    let canvasWidth = canvas.width / this.activeGameData.gameScene.scale.x;
    if (canvasWidth > this.activeGameData.size[0]) {
      moveX = canvasWidth + this.activeGameData.size[0];
    }
    moveX;
    this.setPosition({
      x: this.activeGameData.size[0] / 2,
      y: this.activeGameData.size[1] - this.displayBlackGround.height / 2 + 1,
    });
    this.displayBlackGround.width = canvasWidth;
    this.display_clock.x = -this.activeGameData.size[0] / 2 + 100;
    this.display_gameModeText.x = this.activeGameData.size[0] / 2 - 100;

    //-
    this.gameroundContainer.x = this.display_clock.x + 50;
  };

  public setParents(
    landcapeParent: PIXI.Container,
    portraitParent: PIXI.Container
  ) {
    this.landscapeParent = landcapeParent;
    this.portraitParent = portraitParent;
  }
}
